import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "calendar-chevron-left",
  "use": "calendar-chevron-left-usage",
  "viewBox": "0 0 5.268 9.121",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5.268 9.121\" id=\"calendar-chevron-left\"><g transform=\"translate(-793.896 -324.043)\"><path d=\"M945.942,133.07l4.207,4.207-4.207,4.207\" transform=\"translate(1744.752 465.88) rotate(180)\" fill=\"none\" stroke=\"#8e8e8e\" stroke-width=\"1\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol